import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PipeDriveForm from '../Common/PipedriveForm';

const ArticlePipedriveForm = ({ formId }) => {
  const theme = useTheme();

  return (
    <Box width="100%" bgcolor={theme.palette.alternate.main} paddingTop={8}>
        <Box
          width={{ xs: "100%", sm: 500 }}
          sx={{ margin: "0 auto", paddingX: 2 }}
        >
          <PipeDriveForm formId={formId} height={590}/>
        </Box>
    </Box>
  );
}

export default ArticlePipedriveForm;
